import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { 
    Box, 
    Button, 
    TextField, 
    Grid,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    FormHelperText
} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import { enqueueSnackbar } from 'notistack';

import { useSelector, useDispatch } from 'react-redux';

import Modal from '@mui/material/Modal';
import { constants } from '../../util'
import { showWaiting } from "../../store/slices/configSlice";
import { addAlbumArtist, getAlbumArtistList } from '../../services/albumService';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';



const AddArtist = ({albumId, albumArtistId, open, onClose, maxPercentageAllowed}) => {
    const dispatch = useDispatch();
    const {language, openSignup, deviceType} = useSelector(state => state.configuration);
    const [scroll, setScroll] = React.useState('paper');
    

    //TRANSLATION
    const [t, i18n] = useTranslation("global");


    const sch = (yup) => yup.object({
        name: yup.string().required().min(3).max(40),
        artistTypeId: yup.string().required(),
        urlSpotify: yup.string().url().required().max(500),
        urlApple: yup.string().url().required().max(500),
        urlTiktok: yup.string().url().max(500),
        urlYoutube: yup.string().url().max(500),
        urlInstagram: yup.string().url().max(500),
        urlFacebook: yup.string().url().max(500),
        prctParticipation: yup.number().required().min(1).max(100),
    });
    const schema = useYupSchema(sch);


    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
            resolver: yupResolver(schema),
            defaultValues: {
                name: ' ',
                artistTypeId: 1,
                urlSpotify: ' ',
                urlApple: ' ',
                urlTiktok: ' ',
                urlYoutube: ' ',
                urlInstagram: ' ',
                urlFacebook: ' ',
                prctParticipation: ' '
            }
        });
    

    const handleClose = () => {
        onClose(null);
        reset();
    }


    const onSubmit = (data) => {
        if (data.prctParticipation <= maxPercentageAllowed)
        {
            dispatch(showWaiting(true));
            
            addAlbumArtist(
                albumArtistId,
                albumId.toString(),
                data.name,
                data.artistTypeId, 
                data.urlSpotify, 
                data.urlApple,
                data.urlTiktok,
                data.urlYoutube,
                data.urlInstagram,
                data.urlFacebook,
                data.prctParticipation,
            ).then(
                (rsp) => {
                    setTimeout(() => {
                        if (rsp.code === '00'){
                            onClose({
                                albumArtistId: rsp.metadata?.albumArtistId,
                                name: data.name,
                                artistType: data.type==='1' ? 'Principal' : 'Secundario',
                                artistTypeId: data.artistType,
                                prctParticipation: data.prctParticipation,
                                urlSpotify: data.urlSpotify,
                                urlApple: data.urlApple,
                                urlTiktok: data.urlTiktok,
                                urlInstagram: data.urlInstagram,
                                urlYoutube: data.urlYoutube,
                                urlFacebook: data.urlFacebook,
                            });
                            reset();
                            enqueueSnackbar(
                                language === 'es'
                                    ? 'Artista agregado con éxito'
                                    : 'Artist was added successfully'
                                , { variant: 'success', persist: false });
                        }
                        else
                            enqueueSnackbar(rsp.message, { variant: 'error', persist: false });

                        dispatch(showWaiting(false));
                    }, 1000);
                }
            );
        }
        else{
            // enqueueSnackbar(t("addAlbumGeneral.errorAddArtistMaxPercentage"), { variant: 'error', persist: false });
            enqueueSnackbar(
                language==='es' 
                    ? 'El porcentaje máximo permitido para este artista es ' + maxPercentageAllowed.toString()
                    : 'Max allowed percentage for this artist is  ' + maxPercentageAllowed.toString()
                , { variant: 'error', persist: false });
        }
    }


    useEffect (()=>{
        if (albumArtistId){
            getAlbumArtistList(albumId, albumArtistId===null ? -1 : albumArtistId)
                .then(rsp => {
                    reset(rsp?.metadata)
                })
                .catch(error => {
                    console.log(error);
                })
        }
        else{
            reset({
                    name: '',
                    artistTypeId: 1,
                    urlSpotify: '',
                    urlApple: '',
                    urlTiktok: '',
                    urlYoutube: '',
                    urlInstagram: '',
                    urlFacebook: '',
                    prctParticipation: ''
                });
        }
    }, [open, albumId, albumArtistId, reset])


    return(
        <>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    sx={{ '& .MuiDialog-paper': { width: '80%', maxWidth:'440px', height:'90%', maxHeight: '535px', overflow:'hidden' } }}
                >   
            
                    <DialogTitle id="scroll-dialog-title" sx={{fontSize:'16px', flex:'.1'}}>
                        <b>{t("addAlbumGeneral.addArtist")}</b>
                    </DialogTitle>
                    <Box component='form' onSubmit={handleSubmit(onSubmit)} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <DialogContent dividers={scroll === 'paper'} sx={{ flex: .8, overflow: 'auto' }}>
                        <Grid container spacing={3} direction="column"> 
                            <TextField id="txtName" label={t("signUp.name")} variant="outlined" margin="normal" autoFocus fullWidth sx={{...constants.styles.textfield, marginBottom: '0px'}} 
                                {...register('name')}
                                error={!!errors.name}
                                helperText={errors.name?.message}
                            />

                            <Controller
                                name="artistTypeId"
                                control={control}
                                render={({ field }) => (
                                <FormControl fullWidth error={!!errors.artistTypeId}>
                                    <InputLabel id="country-label">{t("addAlbumGeneral.artistType")}</InputLabel>
                                    <Select
                                        {...field}
                                        label={t("addAlbumGeneral.artistType")}
                                        sx={{ width: '100%' }}
                                    >
                                        <MenuItem value={1}>
                                            <Typography>Artista principal</Typography>
                                        </MenuItem>
                                        <MenuItem value={2}>
                                            <Typography>Artista secundario</Typography>
                                        </MenuItem>
                                    </Select>
                                    <FormHelperText>
                                        {errors.artistTypeId?.message}
                                    </FormHelperText>
                                </FormControl>
                                )}
                            />

                            <TextField id="txtPrctParticipation" label={`${t("addAlbumGeneral.prctParticipation")} - Max = ${maxPercentageAllowed}%`} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '0px'}} 
                                {...register('prctParticipation')}
                                error={!!errors.prctParticipation}
                                helperText={errors.prctParticipation?.message}
                            />

                            <TextField id="txtSpotify" label={t("signUp.spotify")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '0px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/spotity-c.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlSpotify')}
                                error={!!errors.urlSpotify}
                                helperText={errors.urlSpotify?.message}
                            />

                            <TextField id="txtApple" label={t("signUp.apple")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '0px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/apple-c.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlApple')}
                                error={!!errors.urlApple}
                                helperText={errors.urlApple?.message}
                            />

                            <TextField id="txtTiktok" label={t("signUp.tiktok")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '0px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/tiktok-c.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlTiktok')}
                                error={!!errors.urlTiktok}
                                helperText={errors.urlTiktok?.message}
                            />

                            <TextField id="txtYoutube" label={t("signUp.youtube")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '0px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/youtube.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlYoutube')}
                                error={!!errors.urlYoutube}
                                helperText={errors.urlYoutube?.message}
                            />

                            <TextField id="txtInstagram" label={t("signUp.instagram")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '0px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/instagram_color.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlInstagram')}
                                error={!!errors.urlInstagram}
                                helperText={errors.urlInstagram?.message}
                            />

                            <TextField id="txtFacebook" label={t("signUp.facebook")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '0px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/facebook_c.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlFacebook')}
                                error={!!errors.urlFacebook}
                                helperText={errors.urlFacebook?.message}
                            />
                        </Grid>
                    </DialogContent>

                    <DialogActions sx={{flex:'.1'}}>
                        <div style={{display:'flex', width:'100%', paddingTop:'15px', paddingBottom:'10px'}}>
                            <div style={{flex:1}}></div>
                            <Button
                                type="submit"
                                variant="outlined"
                                sx={{ ...constants.styles.mainButton, width: '35%', marginLeft:'10px' }}
                            >
                                {t("addAlbumGeneral.btnSave")}
                            </Button>
                            <Button
                                type="button"
                                variant="outlined"
                                onClick={()=>handleClose()}
                                sx={{ ...constants.styles.secondaryButton, width: '35%', marginLeft:'10px' }}
                            >
                                {t("addAlbumGeneral.btnCancel")}
                            </Button>
                        </div>
                    </DialogActions>
            </Box>
                </Dialog>
        </>
    )
}

export default AddArtist;